<template>
  <div id="bars" :style = "fixbg" v-show="fixBarShow">
    <div class="content" >
       <mal-nav :flexible="true"></mal-nav>
       <div class = "search">
          <search></search>
       </div>
       <div class="menuitem">
         <top-menu-item></top-menu-item>
       </div>
    </div>
  </div>
</template>

<script>
    import Nav from './Nav.vue'
    import search from './search.vue'
    import TopMenuItem from './TopMenuItem.vue'
    export default {
        components:{
          'mal-nav':Nav,
          'search':search,
          'top-menu-item':TopMenuItem,
        },
        data:function () {
            return {
                fixbg:{
                    backgroundImage: "url("+this.$store.state.malMainPageConfig.topbox.bgImgSrc+")"
                },
                fixBarShow:false
            }
        },
        computed:{
          topboxConfig:function(){
            return this.$store.state.malMainPageConfig.topbox;
          }
        },
        methods: {
            handleScroll () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if(scrollTop>225){
                    this.fixBarShow = true;
                }else{
                    this.fixBarShow = false;
                }
            },
        },

        mounted () {
            window.addEventListener('scroll', this.handleScroll)
        },
    }
</script>

<style scoped lang="scss">
  #bars {
    width: 100%;
    height: 66px;
    border-bottom: 1px solid #F98354;
    display: flex;
    align-items: center;
    z-index: 7650;
    position: fixed;
    top: 0;
    opacity: .95;
  }
  #bars .content {
    width: 1200px;
    height: 44px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
  }
  * {
    margin: 0;
    padding: 0;
  }
  div {
    display: block;
  }
  a {
    text-decoration: none;
  }
  #bars .content .search{
    margin-left: 80px ;
  }
</style>
